import axios from 'axios';
import CryptoJS from 'crypto-js';

const AES_KEY = process.env.REACT_APP_ENCRYPTION_AES_KEY;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const login = process.env.REACT_APP_API_USER_LOGIN;
const register = process.env.REACT_APP_API_USER_REGISTER;


export const encryptData = (data, key = AES_KEY) => {
  const dataStr = typeof data === 'object' ? JSON.stringify(data) : data;
  return CryptoJS.AES.encrypt(dataStr, key).toString();
};

export const decryptData = (encryptedData, key = AES_KEY) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, key);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(decrypted);
  } catch {
    return decrypted;
  }
};

export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
};

export const loginUser = async () => {
  try {
    const encryptedPayload = encryptData({
      email: process.env.REACT_APP_DEFAULT_USER_EMAIL,
      password: process.env.REACT_APP_DEFAULT_USER_PASSWORD,
    });

     const response = await axios.post(`${apiBaseUrl}/${login}`, { payload: encryptedPayload });

    if (response.data.status === 'success') {
      localStorage.setItem('jwt_token', response.data.result.token);
    } else {
      throw new Error('Login failed');
    }
  } catch (error) {
    throw error;
  }
};

export const registerUser = async () => {
  try {
    const encryptedPayload = encryptData({
      email: process.env.REACT_APP_DEFAULT_USER_EMAIL,
      password: process.env.REACT_APP_DEFAULT_USER_PASSWORD,
      name: process.env.REACT_APP_DEFAULT_USER_NAME,
      secretkey: process.env.REACT_APP_SECRET_KEY
    });

    const response = await axios.post(`${apiBaseUrl}/${register}`, { payload: encryptedPayload });

    if (response.data.status === 'success') {
      localStorage.setItem('jwt_token', response.data.result.token);
    } else {
      throw new Error('Registration failed');
    }
  } catch (error) {
    throw error;
  }
};
